import baseApi from '../utils/ApiUtils';

export const acquisitionsApi= (method, payload = null, params = null) => {
  return baseApi(`/acquisitions/`, method, params, payload).then(response => {
    return response.data;
  });
};

export const acquisitionsAction= (method,id, payload = null, params = null) => {
  return baseApi(`/acquisitions/${id}/`, method, params, payload).then(response => {
    return response.data;
  });
};

export const acquisitionTransition= (method, id, payload = null, params = null) => {
  return baseApi(`/acquisitions/${id}/transition/`, method, params, payload).then(response => {
    return response.data;
  });
};

export const acquisitionsTaskPoolService= (method, id, payload = null, params = null) => {
  return baseApi(`/acquisitions/${id}/task_pools/`, method, params, payload).then(response => {
    return response.data;
  });
};

export const acquisitionsReportApi = (method, params = null, payload = null) => {
  return baseApi(`reports/acquisitions/?format=csv`, method, params, payload, 'blob').then(response => {
    return response.data;
  });
};